import { styled } from "@pigment-css/react";
import type { CellValue as CellValueType, ColumnType, MonetaryValue } from "../types";

const MonetaryValueContainer = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: theme.managementView.spacing[2],
}));

const MonetaryAmount = styled("div")(({ theme }) => ({
  fontFamily: theme.managementView.font.family,
  fontSize: theme.managementView.font.size[16],
  fontWeight: theme.managementView.font.weight[440],
  letterSpacing: theme.managementView.font.letterSpacing.tight,
  color: theme.managementView.colors.neutral[90],
}));

const PercentageValue = styled("div")(({ theme }) => ({
  fontFamily: theme.managementView.font.family,
  fontSize: theme.managementView.font.size[14],
  fontWeight: theme.managementView.font.weight[400],
  color: theme.managementView.colors.neutral[56],
}));

interface CellValueProps {
  value: CellValueType;
  type: ColumnType;
}

export const CellValue = ({ value, type }: CellValueProps) => {
  if (type === "monetary" && typeof value === "object" && "amount" in value) {
    const monetaryValue = value as MonetaryValue;

    return (
      <MonetaryValueContainer>
        <MonetaryAmount>{monetaryValue.amount}</MonetaryAmount>
        <PercentageValue>{monetaryValue.percentage}</PercentageValue>
      </MonetaryValueContainer>
    );
  }

  if (value === "") return <>-</>;

  return <>{value}</>;
};
